import mixin from './mixin'
export default{
    mixins:[mixin],
    data(){
        return {
            formData: {
                orgRoleName: "FORWARDER", //MERCHANT FORWARDER WAREHOUSE,
                menuLabel:"fbb-web.appoint.agent_app_list",
                search: {
                    EQ_status: null
                }
            },
        }
    }
}